<template>
	<ActivityBadgeLayout class="value-change-activity-badge">
		<FontAwesomeIcon :icon="[ `fas`, `input-numeric` ]" />
	</ActivityBadgeLayout>
</template>

<script>
import ActivityBadgeLayout from "./ActivityBadgeLayout";
export default {
	name: "ValueChangeActivityBadge",
	components: {
		ActivityBadgeLayout,
	},
};
</script>

<style lang="scss" scoped>
$badgeColor: $color1-500;
$badgeBackgroundColor: $color1-100;

.value-change-activity-badge {
	background-color: $badgeBackgroundColor;

	* {
		color: $badgeColor;
	}
}
</style>
